import React, { useState } from 'react';
import { createDriver } from '../../api';

export default function AdminAddDriver({ teams = [], onCreated, setMessage }) {
    const [first, setFirst] = useState('');
    const [last, setLast] = useState('');
    const [teamId, setTeamId] = useState('');

    async function handleAdd() {
        if (!first || !last || !teamId) return setMessage && setMessage('Provide first name, last name and team');
        try {
            const drv = await createDriver(first.trim(), last.trim(), teamId);
            setFirst(''); setLast(''); setTeamId('');
            if (onCreated) onCreated(drv);
            if (setMessage) setMessage(`Added driver ${drv.first_name || drv.firstName} ${drv.last_name || drv.lastName}`);
        } catch (err) {
            console.error('AdminAddDriver error', err);
            setMessage && setMessage('Unable to add driver');
        }
    }

    return (
        <div>
            <h5 className="mb-3">Add New Driver</h5>
            <div className="card mb-3">
                <div className="card-body">
                    <div className="row g-2 align-items-end">
                        <div className="col-auto">
                            <label className="form-label">First name</label>
                            <input className="form-control" value={first} onChange={(e) => setFirst(e.target.value)} />
                        </div>
                        <div className="col-auto">
                            <label className="form-label">Last name</label>
                            <input className="form-control" value={last} onChange={(e) => setLast(e.target.value)} />
                        </div>
                        <div className="col-auto">
                            <label className="form-label">Team</label>
                            <select className="form-select" value={teamId} onChange={(e) => setTeamId(e.target.value)}>
                                <option value="">Select team</option>
                                {(teams || []).map((t) => (
                                    <option key={t.id} value={t.id}>{t.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary" type="button" onClick={handleAdd}>Add Driver</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
